import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { FaEye } from "react-icons/fa";
import { API_BASE_URL } from "../../config";

const ManageTickets = () => {
  const [tickets, setTickets] = useState([]);
  const [search, setSearch] = useState("");

  // Load ticket list from Laravel API
  const loadTickets = async () => {
    try {
      const res = await axios.post(
        `${API_BASE_URL}/my-task`,
        {
          id: localStorage.getItem("user_id") // user assigned_to
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      setTickets(res.data.data || []);
    } catch (err) {
      console.error("Error loading tickets:", err);
    }
  };

  useEffect(() => {
    loadTickets();
  }, []);

  // Search data
  const filtered = tickets.filter((t) =>
    JSON.stringify(t).toLowerCase().includes(search.toLowerCase())
  );

  // Table Column Layout (SAME AS OLD PHP VIEW)
  const columns = [
    {
      name: "Action",
      width: "90px",
      cell: (row) => (
        <FaEye
          className="text-info"
          style={{ cursor: "pointer" }}
          onClick={() => (window.location.href = `/ticket-view/${row.ticket_id}`)}
        />
      ),
    },
    { name: "Ticket Code", selector: (row) => row.ticket_code },
    { name: "Subject", selector: (row) => row.subject },
    {
      name: "Priority",
      selector: (row) => row.tick_priority,
      cell: (row) => (
        <span style={{ color: row.pri_highlight }}>{row.tick_priority}</span>
      ),
    },
    {
      name: "Status",
      selector: (row) => row.tick_status,
      cell: (row) => (
        <span style={{ color: row.sts_highlight }}>{row.tick_status}</span>
      ),
    },
    { name: "Date", selector: (row) => row.created_at },
    {
      name: "Due Date",
      cell: (row) => (
        <>
          {row.complete_by}
          <br />
          {row.overdue_status === "1" ? (
            <span className="badge bg-danger">Overdue</span>
          ) : (
            <span className="badge bg-success">On Due</span>
          )}
        </>
      ),
    },
  ];

  return (
    <div className="card mt-3 p-3">
      <h4>My Task</h4>

      {/* Search bar (optional) */}
      <div className="d-flex justify-content-end mb-2">
        <input
          type="text"
          className="form-control"
          placeholder="Search..."
          style={{ width: 250 }}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* Table */}
      <DataTable
        columns={columns}
        data={filtered}
        pagination
        striped
        highlightOnHover
      />
    </div>
  );
};

export default ManageTickets;
